import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  InputAdornment,
} from "@material-ui/core";
import { useContext } from "react";
import { useState } from "react";
import SelectErp from "../../../../components/basics/SelectErp";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Btn from "../../../../components/buttons/Btn";
import { formatDateGetTime } from "../../../../utils/formatDate";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import useConciliacaoBancariaController from "../controllers/ConciliacaoBancariaController";
import ModalCategorias from "./ModalCategorias";

const ModalNewMovimentation = ({
  open,
  setModalOpen,
  tipo,
  value,
  transactionDate,
  transactionMemo,
  handleNewMovimentation = () => {},
}) => {
  const { createAccountMovimentation } = useConciliacaoBancariaController();

  const { errors, setErrors, bankAccountsList, bankAccount } = useContext(
    ConciliacaoBancariaContext
  );

  const [openModalCateogry, setOpenModalCateogry] = useState(false);
  const [itemCategory, setItemCategory] = useState([]);

  const [historico, setHistorico] = useState(transactionMemo || "");
  const [data, setData] = useState(
    formatDateGetTime({
      date: transactionDate ? new Date(transactionDate) : new Date(),
      separator: "-",
      format: "yyyy-mm-dd-hh:mm:ss",
    })
  );

  const [valor] = useState(
    value ? parseFloat(Math.abs(value)).toFixed(2) : "0.00"
  );
  const [bankAgency] = useState(bankAccount || {});
  const [transferBankAgency, setTransferBankAgency] = useState(null);
  const [checkTransfer, setCheckTransfer] = useState(false);

  const handleClose = () => {
    setErrors({});
    setModalOpen(false);
  };

  const handleAddMovimentation = async () => {
    setErrors({});

    const fields = {
      bankAgency,
      tipo,
      data,
      valor,
      historico,
      checkTransfer,
      transferBankAgency,
      itemCategory,
    };

    const retorno = await createAccountMovimentation(fields);

    if (retorno.success) {
      const newRow = retorno.data;
      newRow.typeBill = "movimentationsBank";
      newRow.typeBillID = `movimentationsBank_${newRow.id}`;

      handleNewMovimentation(newRow);

      handleClose();
    }
  };

  return (
    <>
      {openModalCateogry && (
        <ModalCategorias
          open={openModalCateogry}
          setModalOpen={setOpenModalCateogry}
          content={itemCategory}
          setContent={setItemCategory}
          newBankMoviment={true}
        />
      )}
      <Dialog open={open} fullWidth maxWidth="md">
        <DialogTitle
          id="customized-dialog-title"
          children={<div>Nova Movimentação</div>}
        />
        <DialogContent>
          <Grid container spacing={2} style={{ marginBottom: 20 }}>
            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.bankAgency}
                error={errors.bankAgency ? true : false}
                label="Conta Bancária*"
                value={bankAgency.apelido}
                disabled
              />
            </Grid>

            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.tipo}
                error={errors.tipo ? true : false}
                label="Tipo"
                value={tipo === "CREDIT" ? "Crédito" : "Débito"}
                disabled
              />
            </Grid>

            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.data}
                error={errors.data ? true : false}
                label="Data*"
                type="datetime-local"
                value={data}
                setValue={setData}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
              />
            </Grid>

            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.valor}
                error={errors.valor ? true : false}
                label="Valor*"
                value={valor}
                mask="decimal"
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
                disabled
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ marginBottom: 20 }}>
            <Grid item md={12}>
              <TextFieldErp
                helperText={errors.historico}
                error={errors.historico ? true : false}
                label="Histórico*"
                value={historico}
                setValue={setHistorico}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 20 }}>
            <Grid item md={5}>
              <FormControlLabel
                className="padding-left-10"
                control={
                  <Checkbox
                    checked={checkTransfer}
                    onChange={() => setCheckTransfer(!checkTransfer)}
                    name="transferencia"
                    color="primary"
                  />
                }
                label="Transferência Entre Contas"
              />
            </Grid>

            <Grid item md={3}>
              <SelectErp
                helperText={errors.transferBankAgency}
                error={errors.transferBankAgency ? true : false}
                label={`Conta Bancária${checkTransfer ? "*" : ""}`}
                value={transferBankAgency}
                setValue={setTransferBankAgency}
                optionsList={bankAccountsList}
                descriptionField="apelido"
                disabled={!checkTransfer}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid
              item
              md={4}
              style={{ display: "flex" }}
              justifyContent={"flex-start"}
              alignItems={"flex-end"}
            >
              <Btn
                onClick={() => {
                  setOpenModalCateogry(true);
                }}
                bgcolor="primary"
                hovercolor="orange"
                label={`${
                  itemCategory.length ? "Editar" : "Adicionar"
                } Categorias`}
                fontSize={"12px"}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn onClick={handleAddMovimentation} label="Adicionar" />
          <Btn onClick={handleClose} bgcolor="tertiary" label="Fechar" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalNewMovimentation;
